export const SystemName = 'MSA Levy Estimator'

export const TabletDeviceWidth = 1024
export const MobileDeviceWidth = 768
export const SmallMobileDeviceWidth = 500

export const maxSidebarWidth = 550
export const tabletMaxSidebarWidth = 450

export const SearchControlPlaceholder = 'Search by Address or Standard Parcel ID (SPI)'

export enum basemapTypes {
  esriTile,
  wmts
}

export const acceptedFileTypesForUpload = ['application/x-zip-compressed', 'application/zip']

export const warningMessages = {
  nonUnpaid: 'This %REPLACE_TYPE% has an existing or pending payment',
  crownLand: 'This %REPLACE_TYPE% contains Crown Land',
  conservationArea: 'This %REPLACE_TYPE% contains a conservation area',
  nativeVegRegulationsArea: 'Part of this %REPLACE_TYPE% is outside the MSA program area',
  outsideMsaLevyArea: 'This %REPLACE_TYPE% is outside the MSA levy area',
  twelvePrecincts: 'This %REPLACE_TYPE% overlaps with one of the twelve precincts',
  nonUnpaidAggregate: {
    singular: 'One parcel has an existing or pending payment',
    plural: 'Multiple parcels have an existing or pending payment'
  },
  crownLandAggregate: {
    singular: 'One parcel contains Crown Land',
    plural: 'Multiple parcels contain Crown Land'
  },
  ConservationAreaAggregate: {
    singular: 'One parcel contains a conservation area',
    plural: 'Multiple parcels contain a conservation area'
  },
  nativeVegRegulationsAreaAggregate: {
    singular: 'Part of one parcel is outside the MSA program area',
    plural: 'Parts of multiple parcels are outside the MSA program area'
  },
  outsideMsaLevyAreaAggregate: {
    singular: 'One parcel is outside the MSA levy area',
    plural: 'Multiple parcels are outside the MSA levy area'
  },
  twelvePrecinctsAggregate: {
    singular: 'One parcel overlaps with one of the twelve precincts',
    plural: 'Multiple parcels overlap with one of the twelve precincts'
  }
}
